import { createQuery } from "../../../../../util/graphql";
import CreateUser from "./CreateUser.graphql";

export const createUser = ({
  endpoint,
  clientSlug,
  email,
  password,
  firstName,
  lastName,
  captchaToken
}) =>
  createQuery(endpoint, clientSlug)(CreateUser, {
    user: {
      captchaToken,
      authentication: {
        email,
        password
      },
      person: {
        firstName,
        lastName
      }
    }
  });
